import { Button } from '@modules/ui/core';
import { ErrorPage } from '@lib/errors';

const PageNotFound = () => {
    //Removing button to avoid clickJacking vulnearbility
    return (
        <ErrorPage title='404' message='PAGE NOT FOUND' fullHeight={true}>
            Please use browser back button to navigate to previous page.
        </ErrorPage>
    );
};

export { PageNotFound };
